import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Layout from "./Layout";

const authDisabled = process.env.REACT_APP_AUTH_DISABLED === "true";

/**
 * Protects routes behind authentication.
 * When REACT_APP_AUTH_DISABLED is "true", all routes are accessible (dev mode).
 * Otherwise, unauthenticated users are redirected to /welcome (landing page).
 */
export default function ProtectedRoute() {
  if (authDisabled) {
    return <Outlet />;
  }

  return <AuthGate />;
}

function AuthGate() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <div className="w-8 h-8 border-2 border-[#D4D0C8] border-t-[#2D5016] rounded-full animate-spin" />
        </div>
      </Layout>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/welcome" replace />;
  }

  return <Outlet />;
}
